import React, { useEffect, useState } from "react";
import Spinner from "../../../spinner";
import {Button, Col, notification, Table} from "antd";
import { tableHelper } from "../../../../helpers";
import { companyService } from "../../../../services";
import i18n from "../../../../i18n";

export default function CarrierLegalEntities() {
  const [loading, setLoading] = useState(false);
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [legalEntitiesData, setLegalEntitiesData] = useState(null);

  useEffect(() => {
    if (loading === false) {
      setLoading(true);
      setIsNeedUpdate(true);
    }
  }, [isNeedUpdate]);

  if (isNeedUpdate) {
    companyService
      .getEntitiesListAll()
      .then((response) => {

        setLegalEntitiesData(response);
        setIsNeedUpdate(false);
        setLoading(false);
      })
      .catch((errorMsg) => {
        setIsNeedUpdate(false);
        setErrorMsg(errorMsg);
        setLoading(false);
      });
  }

  if (errorMsg) {
    return <div className="content-error-block">{errorMsg}</div>;
  }

  const handleArchiveLegalEntity = (legalEntityId) => {
      setLoading(true);
      companyService
          .archiveLegalEntity(legalEntityId)
          .then((response) => {
              notification.success(
                  {
                      message: i18n.t('settingsPage.carrierLegalEntities.notification.titles.archive'),
                      description: response.message
                  }
              );

              setIsNeedUpdate(true);
          })
          .catch((err) => {
              notification.error(
                  {
                      message: i18n.t('settingsPage.carrierLegalEntities.notification.titles.archive'),
                      description: err.message
                  }
              );
          });
  }

  const handleUnarchiveLegalEntity = (legalEntityId) => {
      setLoading(true);
      companyService
          .unarchiveLegalEntity(legalEntityId)
          .then((response) => {
              notification.success(
                  {
                      message: i18n.t('settingsPage.carrierLegalEntities.notification.titles.unarchive'),
                      description: response.message
                  }
              );

              setIsNeedUpdate(true);
          })
          .catch((err) => {
              notification.error(
                  {
                      message: i18n.t('settingsPage.carrierLegalEntities.notification.titles.unarchive'),
                      description: err.message
                  }
              );
          });
  }

  const archiveButtonsRenderer = (isArchived, legalEntityId) => {
      if (isArchived === 1) {
          return (
              <>
                  <Button onClick={() => handleUnarchiveLegalEntity(legalEntityId)} size="small" className="small-button typical-btn-green">
                    {i18n.t('settingsPage.carrierLegalEntities.buttons.unarchive')}
                  </Button>
              </>
          );
      } else {
          return (
              <>
                  <Button onClick={() => handleArchiveLegalEntity(legalEntityId)} size="small" className="small-button typical-btn-red">
                    {i18n.t('settingsPage.carrierLegalEntities.buttons.archive')}
                  </Button>
              </>
          );
      }
  };

  const columns = [
      {
          title: i18n.t('settingsPage.carrierLegalEntities.table.name.title'),
          dataIndex: "Name",
          key: "name",
          width: "20%",
          ...tableHelper.getColumnSearchProps("Name", searchText, setSearchText),
      },
      {
          title: i18n.t('settingsPage.carrierLegalEntities.table.archived.title'),
          dataIndex: "Archived",
          width: "5%",
          render: (record) => {
              return record.Archived ? i18n.t('settingsPage.carrierLegalEntities.table.archived.values.yes') : i18n.t('settingsPage.carrierLegalEntities.table.archived.values.no');
          }
      },
      {
          title: "",
          dataIndex: "",
          width: "10%",
          render: (record) => {
              return archiveButtonsRenderer(record.Archived, record.Id);
          }
      }
  ];
  return (
    <React.Fragment>
      <h1 className="content-header">{i18n.t('settingsPage.carrierLegalEntities.title')}</h1>
      <Col span={24}>
        <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
          <Table
            style={{ minWidth: "700px" }}
            columns={columns}
            dataSource={legalEntitiesData}
            locale={{ emptyText: i18n.t('main.empty') }}
            rowKey="name"
            size="small"
            pagination={{
              pageSize: 50,
            }}
          />
        </Spinner>
      </Col>
    </React.Fragment>
  );
}
